import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { createContext, useMemo, useReducer, useRef } from 'react';
var initialState = {};

function reducer(state, action) {
  switch (action.type) {
    case 'init':
      {
        return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.payload, {
          status: 'loading',
          data: null,
          updateTime: Date.now()
        }));
      }

    case 'update':
      {
        return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.payload.key, _objectSpread(_objectSpread(_objectSpread({}, state[action.payload.key]), action.payload.data), {}, {
          updateTime: Date.now()
        })));
      }

    default:
      {
        console.error("Unknown action", action);
        return state;
      }
  }
}

export var RequestCacheContext = /*#__PURE__*/createContext(null);
export var RequestCacheProvider = function RequestCacheProvider(props) {
  var _useReducer = useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      requestCache = _useReducer2[0],
      dispatch = _useReducer2[1];

  var requestCacheRef = useRef(requestCache);
  requestCacheRef.current = requestCache;
  var contextValue = useMemo(function () {
    //In some situation, we need to get the latest requestCache even though we just change it and the rerender is not start. Use Ref to get the latest value.
    var getRequestCache = function getRequestCache(key) {
      var cacheTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var requestCache = requestCacheRef.current;
      if (!key || !requestCache[key]) return null;
      return _objectSpread(_objectSpread({}, requestCache[key]), {}, {
        isOutOfDate: Date.now() - requestCache[key].updateTime > cacheTime
      });
    };

    var updateRequest = function updateRequest(data) {
      dispatch({
        type: 'update',
        payload: data
      });
    };

    var initRequest = function initRequest(data) {
      dispatch({
        type: 'init',
        payload: data
      });
    };

    return {
      requestCache: requestCache,
      updateRequest: updateRequest,
      initRequest: initRequest,
      getRequestCache: getRequestCache
    };
  }, [requestCache]);
  return /*#__PURE__*/React.createElement(RequestCacheContext.Provider, {
    value: contextValue
  }, props.children);
};